import React, { useState, useEffect } from "react";

import { Modal, Checkbox, message } from "antd";

import "./styles.scss";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { CloseOutlined } from "@mui/icons-material";

const ModalConfirmar = ({
  segundoModal,
  setSegundoModal,
  checkAntes,
  checkDepois,
  setModificar,
}) => {

  const [adicionado, setAdicionado] = useState([]);
  const [removido, setRemovido] = useState([]);

  var todosTrue = [];

  checkDepois?.map((d) => {
    if (d.checked) {
      todosTrue?.push(d);
    }
  });

  const naoExisteNasDuas = todosTrue?.filter((obj1) => !checkAntes?.some((obj2) => obj2.id === obj1.id))
    .concat(
      checkAntes?.filter((obj2) => !todosTrue?.some((obj1) => obj1.id === obj2.id))
    );

  useEffect(() => {
    var a = [];
    var r = [];
    naoExisteNasDuas?.map((e) => {
      if (e?.checked == true) {
        a.push(e);
      }
      if (e?.checked == undefined) {
        r.push(e);
      }
    });
    setAdicionado(a);
    setRemovido(r);

    if (a.length < 1 && r.length < 1) {
      setModificar(true);
      setSegundoModal(false);
    }
  }, []);

  return (
    <div>
      <Modal
           title={<span className="modal-title-editar-arquivo " >Confirmar alteração</span>}
        open={true}
        closable={false}
        className="modal-editar-pasta"
        footer={false}
      >
         <CloseOutlined  onClick={() => {
          setSegundoModal(false);
        }} className="custom-close-icon"/>
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              minHeight: '40vh',
            }}
          >
            {adicionado.length > 0 && (
              <div>
                <h3>Permissões adicionadas:</h3>
                <div className="listaTags">
                  {adicionado.map((e, i) => (
                    <div className="tagAdicionada" key={i}>
                      <CheckIcon style={{ marginRight: 10 }} />
                      {e.permissao}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {removido.length > 0 && (
              <div>
                <h3>Permissões removidas:</h3>
                <div className="listaTags">
                  {removido.map((e, i) => (
                    <div className="tagRemovida" key={i}>
                      <CloseIcon style={{ marginRight: 10 }} />
                      {e.permissao}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="editar-pasta-buttons-finalizar-editar">
            <div className="editar-pasta-buttons-publicar">
              <button
                onClick={() => setSegundoModal(false)}
                className="editar-pasta-button-publicar-mim"
              >
                CANCELAR
              </button>

              <button
                className="editar-pasta-button-publicar-todos"
                onClick={() => {
                  setModificar(true);
                  setSegundoModal(false);
                }}
              >
                SALVAR
              </button>
            </div>
          </div>
        </>
      </Modal>
    </div>
  );
};

export default ModalConfirmar;
